<template>
  <div class="user-list container mt-5">
    <h2 class="text-center mb-4">User Details</h2>
    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
    <ul v-if="!loading && !error" class="list-group">
      <li v-for="user in users" :key="user.userID" class="list-group-item">
        {{ user.firstName }} {{ user.lastName }} - {{ user.email }}
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UserDetails',
  data() {
    return {
      users: [],
      loading: false,
      error: ''
    };
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      this.loading = true;
      axios.get('http://127.0.0.1:8000/user_list/')
        .then(response => {
          this.users = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.error = 'There was an error fetching the user list.';
          this.loading = false;
          console.error("There was an error!", error);
        });
    }
  }
}
</script>

<style>
.user-list {
  max-width: 600px;
  margin: auto;
}
</style>
